import config from 'client/config';
import find from "lodash/find";

import Vue from'vue';

export default function (store) {
  const state = {
    instance: undefined,
    type: 'guest',
    roles: {
      admin: false,
      organisation: false,
      event: false,
    },
    organisations: [],
    organisationId: undefined, // only applies for users of type organisation
    eventId: undefined, // only applies for users of type event
    homepage: undefined,
  }

  const actions = {
    "user.set": function (ctx, creds) {
      return Vue.http.get(config.root +'/seUsers/' + creds.id + '/config').then((result) => {
        // result.data.token = creds.token
        store.commit('user.set', result.data.user)
        store.commit('user.setConfig', result.data)
      })
    },
    "user.update": function (ctx, data) {
      return new Promise((resolve, reject) => {
        Vue.http.patch(config.root + '/seUsers/' + data.id, data).then(
          result => {
            if (result.data.id === ctx.state.instance.id) {
              store.commit('user.set', result.data);
            }
            resolve(result)
          },
          error => {
            reject(error)
          })
      })
    },
    "user.logout": function () {
      store.commit('user.set')
    },
    "user.switchOrganisation": function (ctx, organisationId) {
      return new Promise((resolve, reject) => {
        Vue.http.post(config.root + '/seUsers/' + ctx.state.instance.id + '/switch-organisation', { organisationId }).then(
          result => {
            store.commit('user.setConfig', result.data)
            resolve(result)
          },
          error => {
            reject(error)
          }
        )
      })
    }
  };

  const getters = {
    user: (state) =>  (userId) => {
      if (userId === state.instance.id) {
        return state.instance
      }

      return find(store.state.users.items, item => item.id === userId)
    },
  }

  const mutations = {
    "user.set": function (state, inst) {
      Vue.set(state, 'instance', inst)
    },
    "user.setConfig": function (state, config) {
      Vue.set(state, 'type', config.type)
      Vue.set(state, 'roles', config.contextRoles)
      Vue.set(state, 'organisations', config.organisations)
      Vue.set(state, 'organisationId', config.organisationId)
      Vue.set(state, 'eventId', config.eventId)
      Vue.set(state, 'homepage', config.homePage)
    },
  }

  store.registerModule('user', {
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters,
  })
}
